import type {
  ScheduledInventoryDataImportType as Type,
  ScheduledInventoryDataImportStatus as Status,
} from 'contracts/scheduled-inventory-data-imports';

export const getStatusName = (status: Status) => {
  switch (status) {
    case 'pending':
      return 'Em fila de processamento';
    case 'processing':
      return 'Processando importação';
    case 'finished':
      return 'Importação concluída com sucesso';
    case 'canceled':
      return 'Importação cancelada pelo usuário';
    case 'failed':
      return 'Falha de importação';
  }
};

export const getTypeName = (type: Type) => {
  switch (type) {
    case 'blocked-products':
      return 'Importação de Produtos';
    case 'blocked-product-reasons':
      return 'Importação de motivos';
    case 'blocked-product-prices':
      return 'Importação de custos';
    case 'planner-and-material-association':
      return 'Importação de planejadores por produto';
    case 'destination-plant-material-association':
      return 'Importação de materiais por planta de destino';
  }
};